import { createContext, useCallback, useMemo, useState, type ReactNode } from 'react';

type FaqSwitchTrigger = () => void;

type FaqSwitchContextValue = {
  trigger: FaqSwitchTrigger | null;
  setTrigger: (fn: FaqSwitchTrigger | null) => void;
};

export const FaqSwitchContext = createContext<FaqSwitchContextValue>({
  trigger: null,
  setTrigger: () => {},
});

export const FaqSwitchProvider = ({ children }: { children: ReactNode }) => {
  const [trigger, setTriggerState] = useState<FaqSwitchTrigger | null>(null);

  const setTrigger = useCallback((fn: FaqSwitchTrigger | null) => {
    setTriggerState(() => fn);
  }, []);

  const value = useMemo(() => ({ trigger, setTrigger }), [trigger, setTrigger]);

  return <FaqSwitchContext.Provider value={value}>{children}</FaqSwitchContext.Provider>;
};
